import { sidProcessing, saidProcessing } from './idProcessing';
import { STATES, syncidsDebug as debug } from './modules/debug';
/**
 * Goes through all the identifiers and
 * creates the cookie with corresponding name and value, if there are no cookies with this name does not exist
 * @param {Object} ids Mapping of the id parameter name and the cookie value
 * example ids = {
 *   sid: 'id=2148344737436747699|t=1642082846.374|te=1656074072.147|c=5F4C3CD5E69BD4F97AE08419B3054921',
 *   said: 'f3bccd05a2da967b278d0addb4cf9fe0e2ff6d1e50d49ffeefd8'
 * }
 */
export const pushIdentity = (ids) => {
    debug(Object.assign(Object.assign({ message: 'Incoming parameters:' }, { ids }), { state: STATES.START }));
    if (ids === null || ids === void 0 ? void 0 : ids.sid) {
        sidProcessing(ids.sid);
    }
    if (ids === null || ids === void 0 ? void 0 : ids.said) {
        saidProcessing(ids.said);
    }
    debug({ message: 'Synchronization is completed', state: STATES.DONE });
};
